import React from 'react';
import { ChevronRight, FileText, CreditCard, Target, BarChart3, Zap } from 'lucide-react';

const Sidebar = ({ collapsed, onToggle, activeTab, onChangeTab }) => {
  const Item = ({ id, label, icon, gradient }) => {
    const isActive = activeTab === id;
    return (
      <button
        onClick={() => onChangeTab(id)}
        className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
          isActive
            ? `${gradient} text-white`
            : 'text-gray-600 hover:bg-gray-100'
        }`}
        aria-label={label}
      >
        {icon}
        {!collapsed && <span className={isActive ? 'font-medium' : ''}>{label}</span>}
      </button>
    );
  };

  return (
    <>
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className={`${collapsed ? 'hidden' : 'block'}`}>
            <h2 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-purple-400 bg-clip-text text-transparent">
              Finance AI
            </h2>
            <p className="text-xs text-gray-500 mt-1">by Martins Castro</p>
          </div>
          <button
            onClick={onToggle}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Toggle sidebar"
          >
            <ChevronRight
              className={`w-5 h-5 text-gray-600 transition-transform ${collapsed ? '' : 'rotate-180'}`}
            />
          </button>
        </div>
      </div>

      <nav className="flex-1 p-4">
        <div className="space-y-2">
          <Item
            id="invoices"
            label="Invoices"
            icon={<FileText className="w-5 h-5" />}
            gradient="bg-gradient-to-r from-purple-600 to-purple-400"
          />
          <Item
            id="transactions"
            label="Transactions"
            icon={<CreditCard className="w-5 h-5" />}
            gradient="bg-gradient-to-r from-blue-600 to-blue-400"
          />
          <Item
            id="matching"
            label="Matching"
            icon={<Target className="w-5 h-5" />}
            gradient="bg-gradient-to-r from-green-600 to-green-400"
          />
          <Item
            id="analytics"
            label="Analytics"
            icon={<BarChart3 className="w-5 h-5" />}
            gradient="bg-gradient-to-r from-indigo-600 to-indigo-400"
          />
        </div>
      </nav>

      <div className={`p-4 border-t border-gray-200 ${collapsed ? 'hidden' : 'block'}`}>
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-lg p-4 text-white">
          <div className="flex items-start gap-3">
            <Zap className="w-6 h-6 mt-0.5" />
            <div>
              <p className="text-sm font-medium">Pro Tip</p>
              <p className="text-xs mt-1 opacity-90">
                Use o botão <span className="font-semibold">Target</span> para sugerir matches de transações.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
